import { generatePath, Navigate } from "react-router-dom";
import { DOCUMENT_REGISTER_PATH } from "@/modules/document-register/pages/document-register-page";

export function OpenDocumentRegister() {
  const url = new URL(window.location.href);

  return (
    <Navigate
      to={generatePath(DOCUMENT_REGISTER_PATH, {
        registerId: url.searchParams.get("id"),
      })}
    />
  );
}
